const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[ap-expanded-aria]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'ap-expanded-aria',
  confirmMessage: 'data-confirm-message'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }
   
  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}

$( document ).ready(function() {
  $(".banner-normal-product-box").click(function(){
    if($(this).hasClass('active')){
      $(this).removeClass("active");
    }else{
      $(this).addClass("active");
    }
  });
  // header
  if ($(document).scrollTop() < 100) {
		$(".header-transparent").addClass("show");
	}
	$(window).scroll(function() {
		if ($(document).scrollTop() > 100) {
			$(".header").removeClass("show");
		} else {
			$(".header").addClass('show');
		}
	});
  // menu sidebar 
  $("#sidebarCollapse,#dismiss,.overlaysidebar").click(function(){
    if ($("#sidebar,.overlaysidebar").hasClass('active')) {
      $("#sidebar,.overlaysidebar").removeClass('active');
    } else {
      $("#sidebar,.overlaysidebar").addClass("active");
    }
  });
  // countdown
  function loadCountDown() {
    $(".js-countdown").each(function () {
      var time = $(this).data("time").replace("Z", "").split("T");
      var d = time[0].split("-");
      var m = "Jan";
      if (d[1] == 1) m = "Feb";
      if (d[1] == 2) m = "Mar";
      if (d[1] == 3) m = "Apr";
      if (d[1] == 4) m = "May";
      if (d[1] == 5) m = "Jun";
      if (d[1] == 6) m = "Jul";
      if (d[1] == 7) m = "Aug";
      if (d[1] == 8) m = "Sep";
      if (d[1] == 9) m = "Oct";
      if (d[1] == 10) m = "Nov";
      if (d[1] == 11) m = "Nov";
      if (d[1] == 12) m = "Dec";
      var d_t = m + " " + d[2] + ", " + d[0] + " " + time[1];

      var countDownDate = new Date(d_t).getTime();
      var el = $(this);
      var x = setInterval(function () {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        var html = '<div><span class="label-time">' + days + "</span>";
        if (days > 1) {
          html += '<span class="label-countdown">days</span>';
        } else {
          html += '<span class="label-countdown">day</span>';
        }
        html += "</div>";
        html +=
          '<span class="label-dots">:</span><div><span class="label-time">' +
          hours +
          '</span><span class="label-countdown">hours</span></div>';
        html +=
          '<span class="label-dots">:</span><div><span class="label-time">' +
          minutes +
          '</span><span class="label-countdown">mins</span></div>';
        html +=
          '<span class="label-dots">:</span><div><span class="label-time">' +
          seconds +
          '</span><span class="label-countdown">secs</span></div>';
        el.html(html);
        if (distance < 0) {
          el.remove();
        }
      }, 1000);
      $(".off").click(function (e) {
        e.preventDefault();
        clearInterval(x);
      });
    });
  }
  loadCountDown();
  // checkbox emailfooter
  if($("#checkbox-mail-footer").is(":checked")){

  }else{
    $('.newsletter-footer .button').addClass('uncheck');
    $('.newsletter-footer .button').attr('disabled','disabled');
  }
  $("#checkbox-mail-footer").click(function(){
    if($("#checkbox-mail-footer").is(":checked")){
      $('.newsletter-footer .button').removeClass('uncheck');
      $('.newsletter-footer .button').removeAttr('disabled');
    }else{
      $('.newsletter-footer .button').addClass('uncheck');
      $('.newsletter-footer .button').attr('disabled','disabled');
    }
  });
});
